import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingBeefPrimaryDataById, getFootprintingBeefPrimaryDataByIdAdmin } from "services";

import { getEnvironment, shouldRetryQueryError } from "utils";

import { DEFAULT_CACHE, FOOTPRINTING_BEEF_PRIMARY_DATA } from "consts";

export const useGetFootprintingBeefPrimaryDataById = (primaryDataId: string, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_BEEF_PRIMARY_DATA, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingBeefPrimaryDataByIdAdmin(primaryDataId) : getFootprintingBeefPrimaryDataById(primaryDataId)),
      enabled: enabled && !!primaryDataId,
      gcTime: DEFAULT_CACHE.gcTime,
      staleTime: DEFAULT_CACHE.staleTime,
      retry: shouldRetryQueryError(),
    },
    queryClient
  );
};
